<template>
  <div>
    <Map @detail="getDetail" :enterpriseListShow="enterpriseListShow"></Map>
    <map-guide-page @alwaysClose="doAlwaysClose" v-model="guidePageShow" @onStep="doGuideStep"></map-guide-page>
    <div v-if="location.site" class="drawer-show drawer-show-0" @click.stop="doDrawerShow"><i class="el-icon-arrow-left"></i></div>
    <el-drawer append-to-body class="drawer-no-header" :visible.sync="enterpriseListShow" :with-header="false" size="1036">
      <drawer-enterprise-list ref="drawerList" :location="location" v-if="enterpriseListCreateShow">
        <div class="drawer-show-1" @click="doClose"><i class="el-icon-arrow-right"></i></div>
      </drawer-enterprise-list>
    </el-drawer>
    <right-float ref="rightFloat" :globalRfType="true"></right-float>
  </div>
</template>

<script>
import Map from "@/components/qq-map/map.vue"
import mapGuidePage from '@/views/commercialMap/components/mapGuidePage'
import drawerEnterpriseList from '@/views/commercialMap/components/drawerEnterpriseList'
import RightFloat from '@/components/rightFloatBtn'
const guideShowKey = 'map-guide-page'
const mapGuiPageShow = () => !localStorage.getItem(guideShowKey)
export default {
  name: 'commercialMap',
  provide() {
    return {
      unlockSourceType: 5
    }
  },
  components: { Map, mapGuidePage, drawerEnterpriseList, RightFloat },
  data() {
    return {
      input: '',
      enterpriseListCreateShow: false,
      enterpriseListShow: false,
      location: {
        site: null,
        latitude: null,
        longtitude: null,
        distance: 0
      },
      oldPoint: null,
      oldX: 0,
      oldY: 0,
      guidePageShow: mapGuiPageShow(),
      hide: false,
      localCenter: null,
    }
  },
  watch: {
    enterpriseListShow: {
      deep: true,
      immediate: true,
      handler: async function (val, oldVal) {
        await this.$nextTick()
        if (val && this.oldPoint) {
          const width = Math.max(document.body.clientWidth - 1036 - 224, 0)
          const height = Math.max(document.body.clientHeight - 120, 0)
          const { x, y } = map.pointToPixel(this.oldPoint)
          this.oldX = width / 2 - x
          this.oldY = height / 2 - y
          map.panBy(this.oldX, this.oldY)
        } else if (!val && this.oldPoint) {
          map.panBy(-this.oldX, -this.oldY)
        }
        if (!val) {
          this.$refs.drawerList?.dragRefresh?.()
          if (this.$refs.drawerList) {
            const query = { ...this.$route.query }
            if (query.word) {
              delete query.word
            }
            this.$router.replace({ query })
          }
        }
      }
    },
    'location.site': {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        if (val) {
          this.$nextTick(this.resizeDrawerShow0)
        }
      }
    }
  },
  mounted() {
    if (this.$route.query.hide) this.hide = true
    window.onresize = this.resizeDrawerShow0
    window.addEventListener('click', this.clickOutSelectCity)
    const vertical = document.querySelector('.content-scrollbar .is-vertical')
    vertical && (vertical.style.display = 'none')
  },
  created: function () {
    document.onkeydown = function (e) {
      var evt = window.event || event
      if (evt.keyCode === 13) {
        if (evt.preventDefault) {
          evt.preventDefault()
        } else {
          evt.returnValue = false
        }
      }
    }
  },
  methods: {
    async getDetail(data) {
      this.location = data;
      this.enterpriseListCreateShow = true;
      await this.$nextTick()
      this.$refs.drawerList?.initData?.()
      if (data.isEmit) {
        this.enterpriseListShow = true;
      }
    },
    G(id) {
      return document.getElementById(id)
    },
    resizeDrawerShow0() {
      const drawerShow0 = document.querySelector('.drawer-show-0')
      if (!drawerShow0) return
      const app = document.querySelector('#app')
      const offsetWidth = app.offsetWidth
      const scrollWidth = app.scrollWidth
      const dx = 10 - (scrollWidth - offsetWidth)
      const right = Math.max(0, dx)
      drawerShow0.style.right = `${right}px`
    },
    doGuideStep(step) { },
    doClose() {
      this.enterpriseListShow = false
    },
    doAlwaysClose() {
      localStorage.setItem(guideShowKey, 1)
    },
    doDrawerShow() {
      this.enterpriseListShow = true
    },
    clickOutSelectCity(e) {
      const outSelectCity = !this.hasParents(e.target, '.BMap_CityListCtrl') // 点击城市选择器以外的区域
      const citylist_popup_main = document.querySelector('.citylist_popup_main')
      const selectCityIsOpen = citylist_popup_main && citylist_popup_main.style.display === 'block' ? !0 : !1 // 城市选择器是否展开
      if (outSelectCity && selectCityIsOpen) {
        this.triggerClick()
      }
    },

    hasParents(elClass, parentSelectorClass) {
      if (!elClass || !parentSelectorClass) {
        return false
      }
      let [el, parentsSelectors] = [elClass, parentSelectorClass]
      if (typeof elClass === 'string') {
        el = document.querySelector(elClass)
        if (!el) {
          return false
        }
      }
      if (typeof parentsSelectors === 'string') {
        parentsSelectors = document.querySelectorAll(parentsSelectors)
      } else {
        parentsSelectors = [...parentsSelectors]
      }
      let hasParents = false
      for (let i = 0; i < parentsSelectors.length; i++) {
        let p = el.parentNode
        while (p !== parentsSelectors[i]) {
          if (!p || p === document) {
            break
          }
          p = p.parentNode
        }
        if (p === parentsSelectors[i]) {
          hasParents = true
        }
      }
      return hasParents
    },

    triggerClick() { // 自动触发城市列表控件的关闭按钮
      const closeBtn = document.getElementById('popup_close')
      if (document.all) {
        closeBtn && closeBtn.click()
      } else {
        const e = document.createEvent('MouseEvents')
        e.initEvent('click', true, true)
        closeBtn && closeBtn.dispatchEvent(e)
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener('click', this.clickOutSelectCity)
    const vertical = document.querySelector('.content-scrollbar .is-vertical')
    vertical && (vertical.style.display = null)
  }
}
</script>

<style lang="scss" scoped>
.style2 {
  right: 0;
}
.search-box {
  position: absolute;
  z-index: 23;
  background: #fff;
  width: 910px;
  right: -910px;
  height: 100%;
  transition: right 0.8s ease-in-out;
  &.active {
    right: 0px;
    overflow: auto;
  }
  &.active1 {
    right: 0px;
  }
  &.default {
    right: -960px;
  }
  .close {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: -42px;
    background: #ffffff;
    width: 40px;
    height: 90px;
    text-align: center;
    z-index: 3;
    i {
      line-height: 90px;
      font-size: 30px;
    }
  }
}
.drawer-show-1 {
  position: absolute;
  top: 50%;
  transform: translate(-100%, -50%);
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  left: 0;
  cursor: pointer;
  width: 24px;
  height: 40px;
  background: #4286f5;
  border-radius: 4px 0px 0px 4px;
  i {
    transform: translateX(1px);
    animation: my-move 2s infinite;
    animation-direction: alternate; /*轮流反向播放动画。*/
    animation-timing-function: linear; /*动画的速度曲线*/
    // font-size: 20px;
    font-size: 12px;
  }
}

@keyframes my-move {
  0% {
    transform: translateX(1px); /*开始为原始大小*/
  }
  25% {
    transform: translateX(-2px); /*放大1.1倍*/
  }
  50% {
    transform: translateX(1px);
  }
  75% {
    transform: translateX(-2px);
  }
}

.drawer-show {
  z-index: 1;
  position: fixed;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
  color: #2279b5;
  // width: 24px;
  // height: 80px;
  right: 10px;
  // border-radius: 5px 0 0 5px;
  // box-shadow: -3px 1px 3px #0000004c;
  cursor: pointer;
  // background: #fff;

  width: 24px;
  height: 40px;
  background: #4286f5;
  color: #ffffff;
  border-radius: 4px 0px 0px 4px;
  i {
    transform: translateX(1px);
    animation: my-move 2s infinite;
    animation-direction: alternate; /*轮流反向播放动画。*/
    animation-timing-function: linear; /*动画的速度曲线*/
    // font-size: 20px;
    font-size: 12px;
  }
}
::v-deep {
  .el-drawer__body {
    padding: 0;
  }
}
</style>

<style lang="scss">
.tel-dialog {
  .el-dialog__header,
  .el-dialog__footer {
    border: 0 !important;
  }
  .el-dialog__title {
    font-size: 16px;
  }
  .el-dialog__body {
    padding: 10px 50px;
  }
}

.drawer-no-header {
  overflow: hidden;
  .el-drawer {
    overflow: visible;
  }
}
.drawer-no-header .el-drawer__header {
  display: none;
}
</style>
